<div class="flex justify-between items-center pb-4 border-gray-300">
	<h1 class="m-0 text-2xl font-semibold">{{ header }}</h1>
	<div class="flex gap-3">
		<ng-content></ng-content>
	</div>
</div>